import { uniqueId } from "lodash-es";
import type { Group, TrackType } from "./Base";
import { getTextRect } from "@/utils/canvasUtil";
import { ImgClip, OffscreenSprite } from "@webav/av-cliper";
import { UnitFrame2μs } from "@/stores/clip/data/trackConfig";

export interface TextMaterial {
  id: string;
  media_id?: string;
  content?: string;
  fill?: string;
  stroke?: string;
  fontSize?: number;
  fontFamily?: string;
  name?: string;
  angle?: number;
  [k: string]: any;
}

export class TextGroup implements Group {
  id: string;
  type: TrackType = "text";
  name: string;
  isTemplate = false;
  materials: TextMaterial[];
  activeSourceIndex: number;
  frameCount: number;
  start: number;
  end: any;
  offsetL: number;
  offsetR: number;
  [k: string]: any;
  constructor(
    materials: TextMaterial[],
    options: { start?: number; frameCount?: number; isTemplate?: boolean }
  ) {
    // 设置ID
    this.id = uniqueId();
    this.isTemplate = options.isTemplate ?? false;
    this.activeSourceIndex = 0;
    this.materials = materials;

    // 设置轨道信息
    this.frameCount = options.frameCount ?? 5000;
    this.start = options.start ?? 0;
    this.end = this.start + this.frameCount;
  }
}
